import { SpriteIcon } from '@components/Sprites/SpriteIcon';
import { Button } from '@components/UIKit/Button/Button';
import { Divider } from '@components/UIKit/Divider/Divider';
import { useShowToast } from '@hooks/useShowToast';
import { useTranslation } from '@hooks/useTranslation';
import { FC, useCallback } from 'react';
import s from '../BlockFlow/blockProfile.module.scss';
interface Props {
  onCancel: () => void;
  onSubmit: () => void;
  authorName: string;
}
export const UnblockStep: FC<Props> = ({
  onCancel,
  onSubmit,
  authorName
}) => {
  const {
    translate: tr
  } = useTranslation();
  const {
    showToast
  } = useShowToast();
  const handleUnblock = useCallback(async () => {
    try {
      await onSubmit();
    } catch (error) {
      showToast({
        variant: 'error',
        text: 'error.default'
      });
    }
  }, [onSubmit, showToast]);
  return <div className={s.container} data-sentry-component="UnblockStep" data-sentry-source-file="UnblockStep.tsx">
			<div className={s.container__header}>
				<h3 className={s.container__header_title}>
					{tr({
          id: 'unblock.modal.title'
        }, {
          author: authorName
        })}
				</h3>

				<button onClick={onCancel} className={s.container__header_close}>
					<SpriteIcon name='close_small' width={16} height={16} data-sentry-element="SpriteIcon" data-sentry-source-file="UnblockStep.tsx" />
				</button>
			</div>

			<p className={s.container__text}>
				{tr({
        id: 'unblock.modal.description'
      }, {
        author: authorName
      })}
			</p>

			<Divider data-sentry-element="Divider" data-sentry-source-file="UnblockStep.tsx" />

			<div className={s.container__buttons}>
				<Button id='default_button' color='Black' size='large' onClick={handleUnblock} data-sentry-element="Button" data-sentry-source-file="UnblockStep.tsx">
					{tr({
          id: 'btn.unblock'
        })}
				</Button>

				<Button id='default_button' className={s.container__buttons_cancel} color='Transparent' size='large' onClick={onCancel} key='cancel' data-sentry-element="Button" data-sentry-source-file="UnblockStep.tsx">
					{tr({
          id: 'btn.cancel'
        })}
				</Button>
			</div>
		</div>;
};